import {
  handleResponse,
  history,
  removeStorageItem,
  setStorageItem,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function logout() {
  removeStorageItem("user");
  history.push("/login");
}

function login(username, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  };
  const customErrorMsg = "Authentication failed";
  return fetch(`${BASE_URL}/uaa/v1/authenticate`, requestOptions)
    .then((response) => handleResponse(response, customErrorMsg))
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      setStorageItem("user", user);

      return user;
    });
}

export const userService = {
  login,
  logout,
};
